module.exports = __webpack_public_path__ + "static/media/mp-refer-friend.5c5243d5.png";